<!-- TODO remove any type cast in the future once the fontawesome SizeProp has been fixed (for more info, check the input in the code-behind)-->
<fa-icon [icon]="icon" [size]="$any(size)" [ngClass]="{ 'big-icon': bigIcon }" />
